import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
    selector: 'cv-favorite-button-renderer',
    templateUrl: './favorite-button-renderer.component.html',
    styleUrls: ['./favorite-button-renderer.component.scss']
})
export class FavoriteButtonRendererComponent implements AgRendererComponent {
    params: ICellRendererParams;
    addFavoriteTooltip = '';
    removeFavoriteTooltip = '';
    canFavorite: boolean;

    constructor() { }

    agInit(params: ICellRendererParams) {
        this.params = params;
        const { contextUtil } = params?.context;
        this.addFavoriteTooltip = contextUtil?.getAddFavoriteTooltip();
        this.removeFavoriteTooltip = contextUtil?.getRemoveFavoriteTooltip();
        this.params.eGridCell.addEventListener('keypress', () => this.setFavorite());
    }

    refresh(params: ICellRendererParams) {
        this.params = params;
        return true;
    }

    async setFavorite() {
        await this.params.context.contextUtil.setFavorite(this.params.data.DashboardID, !this.params.data.IsFavorite);
    }
}
